import { render } from "./LEQEssay.vue?vue&type=template&id=5beb086b&scoped=true"
import script from "./LEQEssay.vue?vue&type=script&lang=js"
export * from "./LEQEssay.vue?vue&type=script&lang=js"

import "./LEQEssay.vue?vue&type=style&index=0&id=5beb086b&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=5beb086b&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5beb086b"]])

export default __exports__